document.addEventListener("DOMContentLoaded", () => {
  const KODEX_ID = 53522666488138; // ✅ Variant-ID vom Dackel Kodex
  let kodexManuallyRemoved = false;
  let lastSignature = "";

  // --- Hilfsfunktionen ---
  async function getCart() {
    const res = await fetch("/cart.js", { cache: "no-store" });
    return res.json();
  }

  function makeSignature(cart) {
    return (cart.items || []).map(i => `${i.id}:${i.quantity}`).join("|");
  }

 async function updateKodex() {
  try {
    const cart = await getCart();
    const sig = makeSignature(cart);
    if (sig === lastSignature) return;
    lastSignature = sig;

    let hasKette = false;
    let hasBrosche = false;
    let hasKodex = false;

    (cart.items || []).forEach(item => {
      const h = (item.handle || "").toLowerCase();
      if (h.includes("kette")) hasKette = true;
      if (h.includes("brosche")) hasBrosche = true;
      if (String(item.id) === String(KODEX_ID)) hasKodex = true;
    });

    if (kodexManuallyRemoved && !hasKodex) return;

    // ✅ hinzufügen
    if (hasKette && hasBrosche && !hasKodex) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: KODEX_ID, quantity: 1 })
      });
      forceCartUpdate();
      return;
    }

    // ❌ entfernen
    if ((!hasKette || !hasBrosche) && hasKodex) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [KODEX_ID]: 0 } })
      });
      forceCartUpdate();
      return;
    }
  } catch (err) {
    console.warn("⚠️ Fehler beim Kodex-Check:", err);
  }
}

// --- Echtzeit UI-Aktualisierung ---
function forceCartUpdate() {
  // Broadcast-interne Events auslösen
  document.dispatchEvent(new CustomEvent("cart:updated"));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
  // Bundler + Preis-Observer sofort triggern
  setTimeout(() => {
    if (window.Bundler && typeof Bundler.recalculate === "function") Bundler.recalculate();
    document.querySelectorAll('.cart__items, .drawer__body').forEach(el => {
      const obsEvent = new Event('mutation');
      el.dispatchEvent(obsEvent);
    });
  }, 300);
}
  // --- Drawer Refresh ---
function triggerDrawerRefresh() {
  // 1️⃣ Shopify-Objekt manuell neu laden
  fetch('/cart?section_id=cart-drawer')
    .then(r => r.text())
    .then(html => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newBody = tmp.querySelector('.drawer__body');
      const oldBody = document.querySelector('.drawer__body');
      if (newBody && oldBody) {
        oldBody.replaceWith(newBody);
        console.log('♻️ Drawer live aktualisiert (Kodex Add/Remove)');
      }
      // 2️⃣ Theme-internes Event dispatchen (Broadcast erkennt das)
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(err => console.warn('Drawer-Refresh Fehler:', err));
}

  // --- Benutzer entfernt Kodex manuell ---
  document.body.addEventListener("click", e => {
    const btn = e.target.closest("[data-item-remove],[data-cart-remove]");
    if (btn && btn.dataset.id && btn.dataset.id.includes(KODEX_ID)) {
      kodexManuallyRemoved = true;
      console.log("🧩 Kodex manuell entfernt – kein automatisches Hinzufügen mehr.");
    }
  });

  // --- Auf alle Theme-Ajax-Events hören ---
  const events = [
    "cart:refresh",
    "cart:updated",
    "theme:cart:add",
    "theme:cart:change",
    "theme:cart:updated",
    "cart:drawer:updated"
  ];
  events.forEach(ev => document.addEventListener(ev, () => setTimeout(updateKodex, 200)));

  // --- MutationObserver auf Haupt-Container ---
  const container = document.querySelector(".cart__items, .drawer__body");
  if (container) {
    const obs = new MutationObserver(() => setTimeout(updateKodex, 250));
    obs.observe(container, { childList: true, subtree: true });
  }

  // --- Initiale Prüfung ---
  setTimeout(updateKodex, 600);
});